
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gain/growth-vault",
      function () {
        return require("private-next-pages/gain/growth-vault.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gain/growth-vault"])
      });
    }
  